import React from 'react';

import { API } from 'aws-amplify'

import AuthCard from './AuthCard';

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'

class UsernameHandler extends React.Component {
    state = {
        loading: false,
        additional: ''
    }
    handleInputChange = e => {
        this.setState({ additional: e.target.value });
    }

    handleSubmit = e => {
        e.preventDefault();
        const { ccEmail, username, errorType } = this.props;
        const { additional } = this.state;
        this.setState({ loading: true }, () => {
            API.put('AnnalectDatalakeApi', '/support-request', {
                body: {
                    username,
                    ccEmail,
                    errorType,
                    additional,
                }
            }).then(data => {
                this.setState({ loading: false, supportRequested: true });
            }).catch(err => console.log(err));
        });
    }

    render() {
        const { loading, additional, supportRequested } = this.state;
        const { username, errorType, helpText } = this.props;
        if (supportRequested) {
            return <AuthCard loading={loading} {...this.props} title="Log in to Connect"
             subheader={errorType} helpText="Support request has successfully been submitted" helpTextClass="success" />
        }
        return <form onSubmit={this.handleSubmit}>
            <AuthCard loading={loading} {...this.props} title="Log in to Connect" subheader={errorType} helpText={helpText} helpTextClass="error"
                actions={<Button variant="contained" color="primary" disabled={loading} onClick={this.handleSubmit}>Submit</Button>
                }>
                <TextField
                    id="username" name="username" label="Contact Email" autoComplete="off" value={username}
                    fullWidth autoFocus disabled={true} margin="normal"
                /> <TextField
                    id="error_type" name="error_type" label="Error Type" autoComplete="off" value={errorType}
                    fullWidth autoFocus disabled={true} margin="normal"
                />
                <TextField
                    id="additional" name="additional" label="Additional Details" autoComplete="off" value={additional}
                    fullWidth autoFocus disabled={loading} margin="normal" multiline rows={5}
                    onChange={this.handleInputChange}
                />
            </AuthCard>
        </form>
    }
}
export default UsernameHandler;


// WEBPACK FOOTER //
// ./src/Components/Authentication/AuthParts/ErrorHandler.js